import { Button } from "@/components/ui/button";
import { Clipboard, X } from "lucide-react";

interface ClipboardSectionProps {
  clipboardCount: number;
  onClear: () => void;
}

export const ClipboardSection = ({ clipboardCount, onClear }: ClipboardSectionProps) => (
  <div className="flex items-center gap-2">
    <Clipboard className="h-3.5 w-3.5 text-gray-400" />
    <span className="text-sm font-medium text-gray-300">
      {clipboardCount} in clipboard
    </span>
    <div className="h-3.5 w-px bg-gray-700" />
    <Button
      variant="ghost"
      size="sm"
      className="h-7 px-2 text-gray-500 hover:bg-gray-800 hover:text-white"
      onClick={onClear}
    >
      <X className="mr-1 h-3.5 w-3.5" />
      Clear
    </Button>
  </div>
);
